<template>
  <div class="container">
    <div class="header">
      <!-- <img src="../assets/img/logo_white.png" class="header_logo" alt=""> -->
       <h2 style="color: #fff;">Shishan Technology</h2>
      <ul class="header_nav">
        <li @click="toScroll('Games')">Games</li>
        <li @click="toScroll('About')">About</li>
        <li @click="toScroll('Contacts')">Contacts</li>
      </ul>
    </div>
    <div class="fix_nav">
      <!-- <img src="../assets/img/logo_color.png" class="header_logo" alt=""> -->
      <h2 style="color: #000;">Shishan Technology</h2>
      <ul class="header_nav">
        <li @click="toScroll('Games')">Games</li>
        <li @click="toScroll('About')">About</li>
        <li @click="toScroll('Contacts')">Contacts</li>
      </ul>
    </div>
    <div class="banner">
      <div class="banner_text DIN-Bold">
        <h2>Accompany players in</h2>
        <p><span>Discovering the joys</span> of gaming</p>
        <p>:)</p>
      </div>
    </div>
    <div class="games" id="Games">
      <h2>Games</h2>
      <div class="games_box">
        <div class="games_item" v-for="(item,index) in gamesData" :key="index">
          <div class="item_top">
            <video class="video-js" :id="`video_${index}`" :poster="item.videoPoster"></video>
          </div>
          <div class="item_cen">
            <img :src="item.iconUrl" alt="">
            <div class="item_cen_right">
              <div class="item_cen_right_top">
                <p class="DIN-Bold">{{ item.gameName }}</p>
              </div>
              <div class="item_cen_right_down">
                <a :href="item.appStore" class="appBtn" target="_blank" >
                  <img src="../assets/img/Appstore.png" alt="">
                </a>
                <a :href="item.googleStore" class="gooBtn">
                  <div class="gooBtn_div"></div>
                </a>
              </div>
            </div>
          </div>
          <div class="item_down">
            <p>{{ item.gameText1 }}</p>
            <br>
            <p>{{ item.gameText2 }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="about" id="About">
      <h2>About</h2>
      <div class="about_box">
        <div class="about_img"></div>
        <div class="about_text">
          <p>
            Welcome to Guangzhou Shishan Technology Co., Ltd., where innovation meets entertainment. Specializing in casual puzzle games, we are dedicated to crafting engaging and enjoyable experiences for players around the world. Our team of passionate developers and designers work tirelessly to create games that are not only fun but also intellectually stimulating, blending creativity with challenge to capture the imagination of our audience.
          </p>
          <p>
            At Shishan Technology, our commitment is to deliver high-quality, accessible games that offer endless fun and mental stimulation. As we continue to grow, we remain focused on pushing the boundaries of gaming, ensuring that each new release brings a fresh and exciting experience.
          </p>
          <p>
            Join us on our journey as we reshape the world of casual gaming and inspire joy through innovative gameplay.
          </p>
        </div>
      </div>
    </div>
    <div class="contact" id="Contacts">
      <h2>Contacts</h2>
      <div class="contact_form">
        <div style="display: flex; align-items: center; margin: 30px;">
          <img src="../assets/img/icon/icon_email.png" alt="">
          <p style="color: #333;" class="DIN-Bold">shbraingames@outlook.com</p>
        </div>
        <el-form ref="formRef" style="max-width: 600px" label-position="top" :rules="rules" :model="formData" label-width="auto" class="demo-ruleForm" >
          <el-form-item label="Name" prop="name" >
            <el-input v-model="formData.name" type="text" autocomplete="off" />
          </el-form-item>
          <el-form-item label="E-Mail" prop="email">
            <el-input v-model="formData.email" type="text" autocomplete="off" />
          </el-form-item>
          <el-form-item label="Mobile" prop="mobile">
            <el-input v-model="formData.mobile" type="text" autocomplete="off" />
          </el-form-item>
          <el-form-item label="Subject" prop="subject">
            <el-input v-model="formData.subject" type="textarea" autocomplete="off" />
          </el-form-item>
          <el-form-item style="justify-content: space-evenly;">
            <el-button type="primary" @click="submitForm('formRef')">Send</el-button>
            <!-- <el-button @click="resetForm('formRef')">Reset</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <div class="footer_menu">
        <a @click="toPage('/privacy.html')">Privacy Policy</a>
        <a @click="toPage('/terms.html')">Terms of Service</a>
      </div>
      <p>Copyright © 2024.Guangzhou Shishan Technology Co., Ltd. All rights reserved.</p>
    </div>
  </div>
</template>

<script>
// import videojs from "video.js";
export default {
    name:"HomePage",
    data(){
      return{
        scrollHeight:0,
        formData:{},
        gamesData:[
          {
            gameName:"Shanghai Tile - Mahjong Match",
            videoUrl:require("../assets/img/games/8511.png"),
            iconUrl:require("../assets/img/games/mahjong_icon8511.png"),
            videoPoster:require("../assets/img/games/8511.png"),
            gameText1:"Welcome to the captivating world of Shanghai Tile, where the art of matching tiles takes center stage in this exciting puzzle adventure!",
            gameText2:"Immerse yourself in a rich tapestry of Chinese Mahjong-style tiles, each waiting for your strategic touch.",
            appStore:"https://apps.apple.com/us/app/shanghai-tile-mahjong-match/id6505098816",
            googleStore:"",
          },
          {
            gameName:"Cryptoscapes",
            videoUrl:require("../assets/img/games/game1.png"),
            iconUrl:require("../assets/img/games/game4.png"),
            videoPoster:require("../assets/img/games/gameBanner4.png"),
            gameText1:"Enjoy a brand new word journey in Cryptoscapes!",
            gameText2:"Pack your worries away and join us on a quest for brain challenge with Cryptoscapes. Start your journey today and train your brain!",
            appStore:"https://apps.apple.com/us/app/cryptoscapes-brain-word-game/id6504290103",
            googleStore:"",
          },
        ],
        rules:{
          name:{required: true, message: 'Name is required' },
          email:{required: true, message: 'Email is required' },
          mobile:{required: true, message: 'Mobile is required'},
          subject:{required: true, message: 'Subject is required'}
        },
      }
    },
    mounted(){
      window.addEventListener("scroll",this.getScrollHeight);
      // for (let i = 0; i < this.gamesData.length; i++) {
      //   const player = videojs(`video_${i}`, {autoplay: true,preload: "auto",controls: true,});
      //   player.src(this.gamesData[i].videoUrl)
      // }
    },
    methods:{
      // 滚动页面
      toScroll(id){
        document.getElementById(id).scrollIntoView({ behavior: 'smooth' }).catch((err)=>{console.log(err);});
      },
      // 跳转页面
      toPage(path){
        
        this.$router.push({ 'path': path }).catch((err)=>{console.log(err);});
        window.removeEventListener('scroll', this.getScrollHeight)
      },
      getScrollHeight(){
        this.scrollHeight = window.scrollY;
        let navNode = document.getElementsByClassName("fix_nav");
        if (this.scrollHeight>100) {
          if (this.isMobile()) {
            navNode[0].style.padding = "10px"
            navNode[0].style.height = "80px"
          }else{
            navNode[0].style.padding = "10px 250px"
            navNode[0].style.height = "80px"
          }
        }else{
          if (this.isMobile()) {
            navNode[0].style.padding = "0"
            navNode[0].style.height = "0"
          }else{
            navNode[0].style.padding = "0 250px"
            navNode[0].style.height = "0"
          }
        }
      },
      isMobile() {
        // 判断是否为移动设备
        return (
            typeof window.orientation !== "undefined" || // 判断是否存在window.orientation属性，此属性在移动设备上一般存在
            navigator.userAgent.indexOf('IEMobile') !== -1 || // 判断是否为Windows Phone
            navigator.userAgent.indexOf('iPhone') !== -1 || // 判断是否为iPhone
            navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Mobile') !== -1 || // 判断是否为Android手机
            navigator.userAgent.indexOf('BlackBerry') !== -1 || // 判断是否为BlackBerry
            navigator.userAgent.indexOf('Opera Mini') !== -1 // 判断是否为Opera Mini浏览器
        );
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            window.open(
              `mailto:shbraingames@outlook.com?body=${encodeURIComponent(this.formData.subject)}`
            );
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // resetForm(formName) {
      //   this.$refs[formName].resetFields();
      // }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content{
  justify-content: space-evenly !important;
}
.container{
  width: 100%;
  .header{
    position: fixed;
    z-index: 99;
    top: 0;
    width: 100%;
    padding: 10px 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header_logo{
      width: 150px;
      height: auto;
    }
    .header_nav{
      width: 350px;
      list-style: none;
      display: flex;
      justify-content: space-between;
      li{
        color: #fff;
        line-height: 60px;
        font-size: 24px;
        cursor: pointer;
        transition: all .5s ease;
      }
      li:hover{
        color: #3778E5;
      }
    }
  }
  .fix_nav{
    transition: all .3s ease;
    position: fixed;
    z-index: 99999999;
    top: 0;
    height: 0px;
    overflow: hidden;
    background-color: #fff;
    width: 100%;
    padding: 0 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header_logo{width: 150px;}
    .header_nav{
      width: 350px;
      list-style: none;
      display: flex;
      justify-content: space-between;
      li{
        line-height: 60px;
        font-size: 24px;
        cursor: pointer;
        transition: all .5s ease;
      }
      li:hover{
        color: #3778E5;
      }
    }
  }
  .banner{
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 980px;
    background-image: url("../assets/img/top_banner.png");
    background-repeat: no-repeat;
    background-size: cover;
    .banner_text{
      position: absolute;
      text-align: left;
      left: 15%;
      top: 50%;
      transform: translateY(-50%);
      z-index: 9;
      font-size: 36px;
      color: #fff;
      p{
        font-size: 44px;
        margin: 10px 0;
        span{color: #77e3ff;}
      }
    }
    
  }
  .games{
    width: 100%;
    max-width: 1320px;
    margin: 70px auto;
    h2{
      line-height: 60px;
      width: 200px;
      margin: 0 auto;
      background-image: url("../assets/img/titileBG.png");
      background-size: contain;
      background-position-y: 4px;
      background-repeat: no-repeat;
    }
    h2::after{
      content: "";
      position: relative;
      top: -50px;
      left: 8px;
      z-index: 9;
      height: 30px;
      display: block;
      background-image: url("../assets/img/icon/icon_game.png");
      background-repeat: no-repeat;
      background-size: contain;
    }
    .games_box{
      min-width: 400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-evenly;
      align-items: stretch;
      flex-wrap: wrap;
      .games_item{
        max-width: 530px;
        margin-bottom: 50px;
        .item_top{
          width: 500px;
          height: 280px;
          margin-bottom: 30px;
          border-radius: 20px;
          overflow: hidden;
          .video-js{
            width: 100%;
            height: 100%;
            border-radius: 20px;
            object-fit: cover;
          }
        }
        // .item_top::after{
        //   content: " ";
        //   cursor: pointer;
        //   border-radius: 20px;
        //   background-color: rgba($color: #000000, $alpha: .3);
        //   background-image: url("../assets/img/games/icon_play.png");
        //   background-repeat: no-repeat;
        //   background-size: 70px;
        //   background-position: center;
        //   display: inline-block;
        //   position: relative;
        //   left: 0;
        //   top: -100%;
        //   width: 100%;
        //   height: 100%;
        //   z-index: 99999;
        // }
        .item_cen{
          display: flex;
          padding: 0 30px;
          margin-bottom: 30px;
          justify-content: space-between;
          align-items: center;
          img{
            width: 100px;
            height: auto;
            border-radius: 5px;
          }
          .item_cen_right{
            .item_cen_right_top{
              border-left: 3px solid #3778e5;
              padding-left: 10px;
              font-weight: bolder;
              line-height: 35px;
              p{
                max-width: 320px;
                margin-bottom: 20px;
                text-align: left;
                font-size: 26px;
              }
            }
            .item_cen_right_down{
              display: flex;
              align-items: stretch;
              a{position: relative;}
              img,div{width: 150px; height: 50px; margin-right: 10px;}
              .gooBtn::after{
                display: block;
                position: absolute;
                top: 0px;
                left: 0;
                content: " ";
                background-color: rgba($color: #fff, $alpha: .5);
                width: 150px;
                height: 50px;
              }
              .gooBtn{
                .gooBtn_div{
                  width: 150px;
                  height: 50px;
                  background-image: url("../assets/img/Google Play.png");
                  background-size: 100% 100%;
                  position: relative;
                  transition: all .3s ease;
                }
              }
              .gooBtn:hover{
                .gooBtn_div::after{
                  content: " ";
                  position: absolute;
                  z-index: 9999;
                  top: -50%;
                  right: -50%;
                  background-image: url("../assets/img/CStips2.png");
                  background-size: 104px 27px;
                  background-repeat: no-repeat;
                  width: 150px;
                  height: 30px;
                }
              }
            }
          }
        }
        .item_down{
          text-align: left;
          padding: 0 30px;
          color: #717171;
          line-height: 25px;
        }
      }
    }
  }
  .about{
    width: 100%;
    max-width: 1320px;
    margin: 70px auto;
    h2{
      line-height: 60px;
      width: 200px;
      margin: 0 auto;
      background-image: url("../assets/img/titileBG.png");
      background-size: contain;
      background-position-y: 4px;
      background-repeat: no-repeat;
    }
    h2::after{
      content: "";
      position: relative;
      top: -50px;
      left: 8px;
      z-index: 9;
      height: 30px;
      display: block;
      background-image: url("../assets/img/icon/icon_about.png");
      background-repeat: no-repeat;
      background-size: contain;
    }
    .about_box{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      .about_img{
        background-image: url("../assets/img/banner_about.png");
        background-size: cover;
        background-repeat: no-repeat;
        border-radius: 20px;
        position: relative;
        width: 600px;
        height: 500px;
      }
      .about_img::after{
        content: " Shishan Technology ";
        font-size: 36px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        color: #fff;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        // background-image: url("../assets/img/logo_op.png");
        background-size: 200px;
        background-position: center;
        background-repeat: no-repeat;
      }
      .about_text{
        width: 600px;
        text-align: left;
        line-height: 25px;
        p{
          margin: 30px 0;
          padding: 10px;
        }
      }
    }
  }
  .contact{
    width: 100%;
    max-width: 1320px;
    margin: 70px auto;
    h2{
      line-height: 60px;
      width: 200px;
      margin: 0 auto;
      background-image: url("../assets/img/titileBG.png");
      background-size: contain;
      background-position-y: 4px;
      background-repeat: no-repeat;
    }
    h2::after{
      content: "";
      position: relative;
      top: -50px;
      left: 8px;
      z-index: 9;
      height: 30px;
      display: block;
      background-image: url("../assets/img/icon/icon_contacts.png");
      background-repeat: no-repeat;
      background-size: contain;
    }
    .contact_form{
      width: 600px;
      margin: 0 auto;
    }
  }
  .footer{
    width: 100%;
    background-color: #000;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    .footer_menu{
      font-family: "SFUITEXT-REGULAR";
      width: 400px;
      display: flex;
      justify-content: space-evenly;
      a{
        cursor: pointer;
        font-size: 18px;
        color: #B0E0FC;}
    }
    p{
      font-size: 21px;
      color: #fff;
    }
  }
}
@media (max-width:900px) {
  .container{
    .header{
      padding: 10px;
      .header_logo{
        width: 130px;
      }
      .header_nav{
        justify-content: space-evenly;
        width: 300px;
        // li{font-size: 16px;}
      }
    }
    .fix_nav{
      width: 100%;
      padding: 0 250px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .header_nav{
        justify-content: space-evenly;
        width: 300px;
      }
    }
    .banner{
      background-size: cover;
    }
    .games{
      width: 100%;
      h2{
        line-height: 60px;
        width: 200px;
        margin: 0 auto 70px;
        background-color: #77e3ff;
        background-size: 100% 100%;
      }
      .games_box{
        min-width: 400px;
        .games_item{
          max-width: 400px;
          margin: 0 auto;
          margin-bottom: 50px;
          .item_top{
            width: 400px;
            margin-bottom: 30px;
            .video-js{
              width: 100%;
              height: 200px;
              border-radius: 20px;
            }
          }
        }
      }
    }
    .about{
      .about_box{
        justify-content: space-evenly;
        .about_img{width: 90%;}
      }
    }
    .contact{
      .contact_form{
        width: 400px;
      }
    }
  }
}
</style>